import React from 'react';

import { DndDropPlaceholderProps } from '../../../../hooks/useDndDropPlaceholder';

import './DndPlaceholder.scss';

type DndPlaceholderProps = {
  placeholder: DndDropPlaceholderProps;
};

export const DndPlaceholder: React.FC<DndPlaceholderProps> = ({ placeholder }) => {
  return (
    <div
      className="widget-dnd-placeholder"
      style={{
        top: placeholder.clientY,
        left: placeholder.clientX,
        height: placeholder.clientHeight,
        width: placeholder.clientWidth,
      }}
    />
  );
};
